<div class="editor-summary">

  <h4 class="font-20">Riepilogo</h4>

  <div ngbAccordion [closeOthers]="false">
    <div ngbAccordionItem [collapsed]="false">
      <h2 ngbAccordionHeader class="editor-summary-accordion-header">
        <button ngbAccordionButton>Valutazione preliminare di rischio</button>
			</h2>
			<div ngbAccordionCollapse>
				<div ngbAccordionBody class="editor-summary-accordion-body">
          <table class="table table-striped editor-summary-table">
            <thead>
              <tr>
                <th scope="col" style="max-width: calc(100% - 55px); width: calc(100% - 55px);">
                  Scenario
                </th>
                <th scope="col" style="width: 50px; min-width: 50px;">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td class="text-ellipsis">Si</td>
              </tr>
              <tr>
                <td class="text-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</td>
                <td>Si</td>
              </tr>
            </tbody>
          </table>
				</div>
			</div>
		</div>
    <div ngbAccordionItem [collapsed]="true">
      <h2 ngbAccordionHeader class="editor-summary-accordion-header">
        <button ngbAccordionButton>Check Conformità</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody class="editor-summary-accordion-body">
          Check Conformità
        </div>
      </div>
    </div>
    <div ngbAccordionItem [collapsed]="true">
      <h2 ngbAccordionHeader class="editor-summary-accordion-header">
        <button ngbAccordionButton>Probabilità di accadimento delle minacce</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody class="editor-summary-accordion-body">
          Probabilità di accadimento delle minacce
        </div>
      </div>
    </div>
    <div ngbAccordionItem [collapsed]="true">
      <h2 ngbAccordionHeader class="editor-summary-accordion-header">
        <button ngbAccordionButton>Analisi di Impatto (DPIA)</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody class="editor-summary-accordion-body">
          Analisi di Impatto (DPIA)
        </div>
      </div>
    </div>
  </div>
</div>
